"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledDropdownPopper = void 0;
var _DropdownPopper = require("./DropdownPopper");
// TODO: in v9, move styled() from DropdownPopper.jsx to here
var StyledDropdownPopper = _DropdownPopper.DropdownPopper;
exports.StyledDropdownPopper = StyledDropdownPopper;